<template>
  <div>
    <TopBarBackText title="사업자 전용 대량구매" />
    <section class="buy-in-bulk-business-container">
      <nuxt-img
        v-for="url in imageUrl"
        :key="url"
        :src="url"
        class="banner-img"
        :alt="url"
      />
    </section>
    <CtaButton
      id="gtm_bulk_contact_btn"
      class="inquiry-btn w-full"
      bottom-fixed
      size="xl"
      @click="handleClick"
    >
      대량 구매하기
    </CtaButton>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'center'
})

const { ogUrl, ogTitle } = useSeo()

useSeoMeta({
  title: '사업자 전용 대량구매 ',
  description:
    'eSIM, USIM 10개 이상 대량구매를 원하는 사업자를 위한 간편 신청. 문의부터 견적까지 전문 상담 지원. 빠르고 쉽게 대량 구매하세요.',
  ogType: 'website',
  ogUrl: () => ogUrl('buy-in-bulk/business'),
  ogTitle: () => ogTitle('사업자 전용 eSIM, USIM 대량구매 간편 신청 및 무료 견적 상담'),
  ogDescription:
    'eSIM, USIM 10개 이상 대량구매를 원하는 사업자를 위한 간편 신청. 문의부터 구매까지 전문 상담 지원.',
  twitterCard: 'summary',
  twitterTitle: () => ogTitle('사업자 전용 eSIM, USIM 대량구매 간편 신청 및 무료 견적 상담'),
  twitterDescription:
    'eSIM, USIM 10개 이상 대량구매를 원하는 사업자를 위한 간편 신청. 문의부터 구매까지 전문 상담 지원.',
  keywords:
    'eSIM 대량구매, USIM 대량구매, 사업자 대량구매, 데이터로밍, 글로벌 eSIM, 이심, 유심, 유심사, 기업 대량구매',
  ogSiteName: '유심사 사업자 전용 대량구매'
})

const { bulkUrl } = useRuntimeConfig().public

const handleClick = () => {
  window.open(String(bulkUrl), '_blank')
}

const imageUrl = [
  '/img/bulk/Bulk-Image-1-v2.png',
  '/img/bulk/Bulk-Image-2-v2.png',
  '/img/bulk/Bulk-Image-3-v2.png',
  '/img/bulk/Bulk-Image-4-v2.png'
]
</script>

<style lang="scss" scoped>
.buy-in-bulk-business-container {
  padding-top: 56px;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
